import styled from 'styled-components';
import { Skeleton } from '@elfsight/widget-ui';

interface MediaSkeletonProps {
  backgroundColor?: string;
}

export function MediaSkeleton({ backgroundColor }: MediaSkeletonProps) {
  return (
    <SkeletonContainer _backgroundColor={backgroundColor}>
      <Skeleton width="100%" height="100%" borderRadius={0} />
    </SkeletonContainer>
  );
}

const SkeletonContainer = styled.div<{ _backgroundColor?: string }>`
  position: absolute;
  inset: 0;
  z-index: 10;
  background: ${({ _backgroundColor }) => _backgroundColor ?? '#fff'};
`;
